import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';

import { Input, Radio, message, Spin, Modal, Button, Row, Col, Form } from 'antd';
import CKEditorUtil from '../../../../utils/ckEditorUtil'
import efn from './LecturerUpsertPageFns'
import moment from 'moment';

function LecturerUpsertPage(props) {
  const { lang, lecturerMap } = props
  const [form] = Form.useForm();
  const { TextArea } = Input
  const [langLecturer, setLangLecturer] = useState()
  const [editorData, setEditorData] = useState();
  let setFuncMap = { setLangLecturer, setEditorData, ...props.setFuncMap }
  const onFinish = values => {
    values["lang"] = lang
    values["content"] = editorData
    efn.updateLecturer(values, props, setFuncMap)
  };

  useEffect(() => {
    setLangLecturer(lecturerMap[lang])
    form.setFieldsValue(lecturerMap[lang])
  }, [lecturerMap])

  useEffect(() => {
    form.setFieldsValue(langLecturer)
  }, [langLecturer])

  return (
    <Form
      form={form}
      layout="horizontal"
      onFinish={onFinish}
    >
      <CKEditorUtil setFuncMap={setFuncMap} defaultValue={langLecturer ? langLecturer.content : null} />
      <Form.Item
        name="id"
        hidden
      >
        <Input type="hidden" />{langLecturer && langLecturer.lastUpdateAt && `最後更新時間: ${moment(langLecturer.lastUpdateAt).format("yyyy-MM-DD HH:mm:ss")}`}
      </Form.Item>
      <Row justify={"center"} gutter={16}>
        <Col>
          <Button type="primary" htmlType="submit">
            更新
          </Button>
        </Col>
      </Row>

    </Form>
  );
}



export default React.memo(LecturerUpsertPage);
